(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
  function setupMarquee() {
    const marquee = document.querySelector('.hb-image-marquee');
    const track = marquee.querySelector('.marquee-track');
    track.style.animation = 'none';
    const contentWidth = track.scrollWidth;
    const containerWidth = marquee.offsetWidth;
    const duration = contentWidth / 100;
    const animName = 'marqueeScroll-' + Math.floor(Math.random() * 10000);
    const keyframes = `
    @keyframes ${animName} {
      0% { transform: translateX(0); }
      100% { transform: translateX(-${contentWidth / 2}px); }
    }
  `;
    const style = document.createElement('style');
    style.innerHTML = keyframes;
    document.head.appendChild(style);
    track.style.animation = `${animName} ${duration}s linear infinite`;
  }
  window.addEventListener('load', setupMarquee);
  window.addEventListener('resize', setupMarquee);

  } catch(e) { console.error(e); }
})();
})();
